export default __webpack_public_path__ + "static/media/3. Akt priema biomateriala ginekologiya.3bf48853.pdf";